import i18n from "@/language"

export const getRitualSectionTips = (sectionId: string | null) => {
  const key = sectionId || "info"
  const tips: string[] = i18n.t(`sectionTips.${key}`, {
    ns: "rituals",
    returnObjects: true,
    defaultValue: [],
  }) as unknown as string[]
  return {
    title: i18n.t("tips", { ns: "rituals" }) as string,
    tips,
    showPreview: key === "media",
  }
}
